import apiRequest from './apiRequest';

export type EarlyTrialCompletionResponse = {
  subscriptionId: string;
  status: string;
};

export default async function earlyTrialCompletion() {
  return apiRequest<EarlyTrialCompletionResponse>(
    'user',
    '/users/earlyTrialCompletion',
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  );
}
